export enum POSITIONS {
  LEFT = 'LEFT',
  RIGHT = 'RIGHT',
}
